<template>
  <div>
    <v-lp-tool-bar/>
  </div>
</template>

<script>
import VLpToolBar from '@/components/organisms/lp/VLpToolBar.vue'
export default {
  components: {
    VLpToolBar
  }
}
</script>
